module.exports = __webpack_public_path__ + "static/media/apple.13efbb75.png";